//Реакт
import React, { useState, useLayoutEffect, useContext } from "react";
//Библиотеки и Api
import ApiCdr from "../../../../../app/api/authorized/admin/management/ApiCdr";
import DateLib from "../../../../../inc/DateLib";
//Модули Content
import Page from "../../../../modules/page";
import { ContextPage } from "../../../../modules/page/pageContext";
import { ContextContent } from "../../../../modules/content/contentContext";
//Модули view
import List from "../../../../modules/list";
import ListHeaderItem from "../../../../modules/list/__header-item";
import ListBodyItem from "../../../../modules/list/__body-item";
//Компоненты
import InputPhone from "../../../../components/inputs/phone/phone";
import InputDate from "../../../../components/inputs/date/date";
//Material UI
import AudioPlayer from "../../../../components/audio-player";
//Стили
import './styles.css';

export default function CdrIndex({ ...other }) {
    return <Page {...other}>
        <CdrIndexContent {...other} />
    </Page>
}

function CdrIndexContent({ ...other }) {
    const contextContent = useContext(ContextContent);
    const contextPage = useContext(ContextPage);

    const [_phone_source, set_phone_source] = useState('');
    const [_phone_destination, set_phone_destination] = useState('');
    const [_call_start, set_call_start] = useState('');
    const [_call_end, set_call_end] = useState('');

    const formatDuration = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };
    

    useLayoutEffect(() => {
        contextPage.setTitle(`Звонки`);
        contextContent.setTitle(`Звонки`);
    }, [contextContent, contextPage]);
    const header = [
        <ListHeaderItem
            key="source"
            name="source"
            isSort={false}
        >
            Кто звонил
        </ListHeaderItem>,
        <ListHeaderItem
            key="destination"
            name="destination"
            isSort={false}
        >
            Кому звонил
        </ListHeaderItem>,
        <ListHeaderItem
            key="call_recodring"
            name="call_recodring"
            isSort={false}
        >
            Запись
        </ListHeaderItem>,
        <ListHeaderItem
            key="call_duration"
            name="call_duration"
            isSort={false}
        >
            Длительность звонка
        </ListHeaderItem>,
        <ListHeaderItem
            key="start_time"
            name="start_time"
        >
            Дата начала звонка
        </ListHeaderItem>,
        <ListHeaderItem
            key="end_time"
            name="end_time"
        >
            Дата окончания звонка
        </ListHeaderItem>,
        <ListHeaderItem
            key="id"
            name="id"
        >
            №
        </ListHeaderItem>,
    ];

    const filters = [
        <InputPhone className="input_wf" useReg={false} value={_phone_source} onChange={(e) => { set_phone_source(e.target.value) }}>Кто звонил</InputPhone>,
        <InputPhone className="input_wf" useReg={false} value={_phone_destination} onChange={(e) => { set_phone_destination(e.target.value) }}>Кому звонил</InputPhone>,
        <InputDate className="input_wf" value={_call_start} onChange={(e) => { set_call_start(e.target.value) }}>Дата начала звонка</InputDate>,
        <InputDate className="input_wf" value={_call_end} onChange={(e) => { set_call_end(e.target.value) }}>Дата окончания звонка</InputDate>,
    ];

    const renderRow = (row, i) => {
        return [
            <ListBodyItem className="admin-cdrs-width" key="source" data-label={header[0].props.children}>{row.source}</ListBodyItem>,
            <ListBodyItem className="admin-cdrs-width" key="destination" data-label={header[1].props.children}>{row.destination}</ListBodyItem>,
            <ListBodyItem className="admin-cdrs-width-250" key="call_recodring" data-label={header[2].props.children}>
                {row.call_recodring ? (
                    <AudioPlayer src={row.call_recodring} />
                ) : (
                    'Нет записи'
                )}
            </ListBodyItem>,
            <ListBodyItem className="admin-cdrs-width" key="call_duration" data-label={header[3].props.children}>{row.call_duration ? formatDuration(row.call_duration) : null}</ListBodyItem>,
            <ListBodyItem className="admin-cdrs-width" key="start_time" data-label={header[5].props.children}>{DateLib.formatterDateTime(row.start_time)}</ListBodyItem>,
            <ListBodyItem className="admin-cdrs-width" key="end_time" data-label={header[6].props.children}>{DateLib.formatterDateTime(row.end_time)}</ListBodyItem>,
            <ListBodyItem className="admin-cdrs-width" key="id" data-label={header[0].props.children}>{row.id}</ListBodyItem>,
        ];
    }

    return <>
        <List
            header={header}
            filters={filters}
            ApiModel={ApiCdr}
            renderRow={renderRow}
            defaultSortKey='id'
            searchParams={{ phoneSource: _phone_source, phoneDestination: _phone_destination, callStart: _call_start, callEnd: _call_end }}
        />
    </>
}
